import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import TradesIcon from '@interxfi/design-system/icons/react/icon-trades';
import { PlaidProcessorTokenConfirmSyncAllDialog } from '../../../../../../../../../../features/vendor/plaid/processor-token/plaid-processor-token-sync-all-confirm-dialog';
import { PlaidProcessorTokensTable } from '../../../../../../../../../../features/vendor/plaid/processor-token/plaid-processor-tokens-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/processor-token/_processor-token/')({
  head: () => getPageHead('Plaid Processor Tokens'),
  component: PlaidProcessorTokensList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <RequiresAccess write>
        <PlaidProcessorTokenConfirmSyncAllDialog
          trigger={
            <Button affixIcon={<TradesIcon aria-hidden />} aria-label="Sync All Plaid Processor Tokens" size="small">
              Sync All
            </Button>
          }
        />
      </RequiresAccess>

      {filter}
    </HorizontalStack>
  );
}

function PlaidProcessorTokensList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <PlaidProcessorTokensTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
